import axios from 'axios';

// Railway backend behind our own domain. Must stay on *.trustnride.in so the login cookie
// (SameSite=strict) is sent - the raw *.up.railway.app URL would be a different site.
export const API_BASE_URL = 'https://backend.trustnride.in/api';
// For local testing (backend on your machine):
// export const API_BASE_URL = 'http://localhost:5000/api';

// Client for cookie-authenticated endpoints (auth, analytics, invoices).
// withCredentials sends the httpOnly auth cookie; the token is never readable from JS.
export const authApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});
